export default __webpack_public_path__ + "static/media/avtomaticaEnergoSis.3485867e.pdf";